import React, { useState, useEffect, useRef } from 'react';
import services from '../../services';
import { useDispatch } from 'react-redux';
import { setAllAssignUser } from '../../Redux/slice';
import { toast } from 'react-toastify';
const bootstrapColors = ['bg-primary', 'bg-success', 'bg-danger', 'bg-warning', 'bg-info', 'bg-secondary'];

const AssignDropdown = ({
    selectedMail,
    currentTaskId,
    getAllTask,
    taskAssign,
    setSelectedAssighUser,
    handleAssign,
    handleInputChange,
    handleClearAssignment,
    type,
    taskItem,
    onClose,
    openAssignDropdownTaskId,
    selectedBoardId,
}) => {
    const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
    const assignRef = useRef(null);
    const [userList, setUserList] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const selectedUserObj = userList.find((user) => user.id === selectedUser);
    const [searchTerm, setSearchTerm] = useState('');
    const dispatch = useDispatch();
    const [userEmail, setUserEmail] = '';

    useEffect(() => {
        function handleClickOutside(event) {
            if (assignRef.current && !assignRef.current.contains(event.target)) {
                setIsSearchBoxOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleChange = async (userObj) => {
        if (type == 'DateTable') {
            setSelectedAssighUser(userObj?.id);
        }

        setSelectedUser(userObj.id);
        dispatch(setAllAssignUser(userObj.id));
        setIsSearchBoxOpen(false);

        if (onClose) onClose();
        if (selectedMail?.boardId === null) {
            toast.error('Please select a board and column before adding a comment.');
            return;
        }
        try {
            const data = { userId: userObj.id };
            const response = await services.task.UPDATE_TASK_GMAIL_WHATSAAP(
                currentTaskId || openAssignDropdownTaskId,
                data,
            );
        } catch (error) {
            console.error('Error updating task:', error);
        }
    };

    const getAllUserList = async () => {
        try {
            const page = 1;
            const falsePagination = false;
            const response = await services.userassignboard.GET_ASSIGN_USER_BY_BOARD_ID(
                selectedBoardId,
                '',
                falsePagination,
            );
            const allData = response?.data?.data || [];
            const uniqueUsers = Array.from(new Map(allData.map((item) => [item.userId, item.User])).values());

            setUserList(uniqueUsers);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAllUserList();
    }, [selectedBoardId]);

    useEffect(() => {
        let timeoutId;

        if (taskItem?.userId && Array.isArray(userList)) {
            const assignedUser = userList.find((user) => user.id === taskItem.userId);

            timeoutId = setTimeout(() => {
                if (assignedUser) {
                    setSelectedUser(assignedUser.id);
                } else {
                    setSelectedUser(null);
                }
            }, 1500);
        }

        return () => {
            clearTimeout(timeoutId);
        };
    }, [taskItem?.userId, userList]);

    const filteredUsers = userList.filter(
        (user) =>
            user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (user.email && user.email.toLowerCase().includes(searchTerm.toLowerCase())),
    );
    return (
        <div className="relative inline-block text-left" ref={assignRef}>
            <a
                href="#"
                className="text-listdrop !text-[11px]"
                style={{ textDecoration: 'none' }}
                onClick={(e) => {
                    e.preventDefault();
                    setIsSearchBoxOpen((prev) => !prev);
                }}
            >
                {selectedUserObj ? (
                    <div className="flex items-center">
                        <span className="w-7 h-7 rounded-full bg-[#512da8] text-white flex items-center justify-center mr-2 text-sm font-bold">
                            {selectedUserObj.name?.charAt(0).toUpperCase()}
                        </span>
                        <span className="text-sm">{selectedUserObj.name}</span>
                    </div>
                ) : type === 'DateTable' ? (
                    ''
                ) : (
                    'Assign...'
                )}
            </a>

            {(type === 'DateTable' || isSearchBoxOpen) && (
                <div
                    className={`absolute ${
                        type === 'DateTable' ? 'top-[-0.5vw] left-[-12vw] w-[250px]' : 'top-[1vw] left-0'
                    } search-assign p-2 bg-white rounded-lg shadow-lg w-[260px] mt-2`}
                >
                    <div className="flex justify-between items-center">
                        <label className="text-gray-700 font-semibold text-sm uppercase fs-8">ASSIGN TO</label>
                        <a
                            href="#"
                            className="text-blue-500 text-sm hover:underline fs-8"
                            style={{ textDecoration: 'none' }}
                            onClick={(e) => {
                                e.preventDefault();
                                handleClearAssignment();
                                setSelectedUser(null);
                                setSearchTerm('');
                            }}
                        >
                            Clear
                        </a>
                    </div>
                    <div className="flex flex-col items-start font-google rounded-2xl">
                        <input
                            type="text"
                            placeholder="Search by name"
                            className="inputField-text mb-2 w-full"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            data-no-popup
                            style={{ backgroundColor: 'white' }}
                        />
                        {
                            <ul className="assign-box min-w-[11.5vw] rounded-2xl z-10 max-h-60 overflow-y-auto w-full">
                                {filteredUsers.length === 0 ? (
                                    <li className="p-2 text-gray-400">No users found</li>
                                ) : (
                                    filteredUsers.map((item, index) => (
                                        <li
                                            key={item.id}
                                            className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={() => handleChange(item)}
                                            data-no-popup
                                        >
                                            <span className="avatar-mail text-white bg-cyan-600 w-6 h-6 flex items-center justify-center rounded-full font-bold">
                                                {item.name.charAt(0).toUpperCase()}
                                            </span>
                                            {item.name}
                                        </li>
                                    ))
                                )}
                            </ul>
                        }
                    </div>
                </div>
            )}
        </div>
    );
};

export default AssignDropdown;
